import React from 'react';

const FullDanteLogoGreyIcon = ({ className = '', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="12"
    viewBox="0 0 48 12"
    fill="none"
    className={className}
    {...props}
  >
    <mask
      id="mask0_5254_5986"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="12"
      height="12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.211845 4.61884C1.21586 1.26296 4.02705 0.27594 5.03105 0.0785351C6.03505 -0.118869 8.8463 -0.11887 10.0512 2.24998C12.26 3.63184 12.2599 6.3955 11.6575 7.97475C11.0552 9.554 8.8463 12.515 5.03105 11.9228C3.62544 11.7254 2.42068 10.541 2.01908 9.75135C1.08199 9.15915 -0.591359 7.3035 0.211845 4.61884ZM2.54248 9.2207C2.22384 8.70325 1.77178 7.30745 2.51267 5.86405C3.43879 4.05983 4.01866 3.51985 4.90614 3.02166C6.01345 2.40006 7.59355 1.54786 9.47925 2.72755C10.5972 4.99172 9.2631 7.22655 8.08545 8.33295C6.9078 9.4394 4.72871 10.5334 2.54248 9.2207Z"
        fill="#9387FD"
      />
    </mask>
    <g mask="url(#mask0_5254_5986)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.211845 4.61884C1.21586 1.26296 4.02705 0.27594 5.03105 0.0785351C6.03505 -0.118869 8.8463 -0.11887 10.0512 2.24998C12.26 3.63184 12.2599 6.3955 11.6575 7.97475C11.0552 9.554 8.8463 12.515 5.03105 11.9228C3.62544 11.7254 2.42068 10.541 2.01908 9.75135C1.08199 9.15915 -0.591359 7.3035 0.211845 4.61884ZM2.54248 9.2207C2.22384 8.70325 1.77178 7.30745 2.51267 5.86405C3.43879 4.05983 4.01866 3.51985 4.90614 3.02166C6.01345 2.40006 7.59355 1.54786 9.47925 2.72755C10.5972 4.99172 9.2631 7.22655 8.08545 8.33295C6.9078 9.4394 4.72871 10.5334 2.54248 9.2207Z"
        fill="#9387FD"
      />
      <g filter="url(#filter0_f_5254_5986)">
        <path
          d="M8.452 2.999C6.87615 1.29187 4.42923 4.57517 3.03516 5.9154C3.40927 2.26 6.92065 1.36429 8.214 1.79144C10.3519 2.49753 9.5502 4.18868 8.452 2.999Z"
          fill="url(#paint0_linear_5254_5986)"
        />
      </g>
      <path
        d="M11.2057 7.9845C12.0912 4.41925 10.4253 2.99336 9.48168 2.72607L7.58203 8.47575L9.18868 11.7568C9.49213 11.9848 10.3203 11.5497 11.2057 7.9845Z"
        fill="url(#paint1_linear_5254_5986)"
      />
      <g filter="url(#filter1_f_5254_5986)">
        <path
          d="M10.8891 8.75424C11.1674 7.93244 11.6378 6.00709 11.293 4.8802C10.8621 3.47157 9.77248 2.5992 8.64453 2.44775"
          stroke="url(#paint2_linear_5254_5986)"
          strokeWidth="0.100401"
        />
      </g>
      <g filter="url(#filter2_f_5254_5986)">
        <path
          d="M10.9663 8.81346C11.2446 7.99161 11.715 6.06626 11.3702 4.93937C10.9393 3.53074 9.65139 2.46102 8.52344 2.30957"
          stroke="url(#paint3_linear_5254_5986)"
          strokeWidth="0.200803"
        />
      </g>
      <g filter="url(#filter3_f_5254_5986)">
        <path
          d="M3.76918 3.83508C5.26075 0.918173 8.5751 1.56546 10.0458 2.25372L9.74959 0.876147L8.13785 -0.612853L5.4193 -0.784668L0.972656 1.697C1.28335 3.62507 2.27763 6.752 3.76918 3.83508Z"
          fill="url(#paint4_linear_5254_5986)"
        />
      </g>
      <g filter="url(#filter4_f_5254_5986)">
        <path
          d="M3.77972 4.25253C3.71504 3.55552 4.98224 1.922 6.43134 1.73555C8.24274 1.5025 10.5859 2.01429 11.5143 3.34732"
          stroke="url(#paint5_linear_5254_5986)"
          strokeWidth="0.100401"
        />
      </g>
      <g filter="url(#filter5_f_5254_5986)">
        <path
          d="M3.91063 3.85446C3.22859 4.76485 2.69981 7.78942 2.54734 9.22737C-0.52121 7.46642 0.79728 3.12164 0.87427 2.87743C0.300603 4.42091 0.8777 2.86669 0.8777 2.86669C0.8777 2.86669 0.87651 2.87032 0.87427 2.87743C0.8756 2.87385 0.876935 2.87025 0.87828 2.86664C2.4607 2.65786 4.59267 2.94406 3.91063 3.85446Z"
          fill="url(#paint6_linear_5254_5986)"
        />
      </g>
      <g opacity="0.5" filter="url(#filter6_f_5254_5986)">
        <path
          d="M1.813 1.83301C0.580065 3.19047 -0.537495 6.45214 1.6309 8.54309C3.7993 10.634 6.74193 9.85599 7.64528 8.54309"
          stroke="url(#paint7_linear_5254_5986)"
          strokeWidth="0.140562"
        />
      </g>
      <g opacity="0.7" filter="url(#filter7_f_5254_5986)">
        <path
          d="M0.410156 8.27393C2.90118 10.3648 6.3053 9.34063 7.69595 8.56713C6.29525 9.70613 2.87714 11.2421 0.410156 8.27393Z"
          fill="white"
        />
        <path
          d="M0.410156 8.27393C2.90118 10.3648 6.3053 9.34063 7.69595 8.56713C6.29525 9.70613 2.87714 11.2421 0.410156 8.27393Z"
          stroke="white"
          strokeWidth="0.401607"
        />
      </g>
      <g filter="url(#filter8_f_5254_5986)">
        <path
          d="M1.79297 9.64303C3.00193 10.2605 5.82428 11.0136 7.44213 9.08583C8.47933 7.84993 8.89758 7.21858 9.02568 6.92788V6.71363C9.07818 6.70913 9.09743 6.76513 9.02568 6.92788V11.6736C6.92208 12.4826 2.53046 13.2092 1.79297 9.64303Z"
          fill="url(#paint8_linear_5254_5986)"
        />
        <path
          d="M1.79297 9.64303C3.00193 10.2605 5.82428 11.0136 7.44213 9.08583C8.47933 7.84993 8.89758 7.21858 9.02568 6.92788V6.71363C9.07818 6.70913 9.09743 6.76513 9.02568 6.92788V11.6736C6.92208 12.4826 2.53046 13.2092 1.79297 9.64303Z"
          fill="url(#paint9_linear_5254_5986)"
        />
      </g>
      <g filter="url(#filter9_f_5254_5986)">
        <path
          d="M3.19141 11.1594C3.61934 11.5966 4.91326 12.381 6.66547 12.022C8.85572 11.5732 10.3538 10.3179 10.8104 9.60957C11.2669 8.90127 12.0777 7.36032 12.1343 6.61572"
          stroke="url(#paint10_linear_5254_5986)"
          strokeWidth="0.200803"
        />
      </g>
      <g filter="url(#filter10_f_5254_5986)">
        <path
          d="M0.913701 2.80518C-0.31557 6.03257 -0.785074 6.95527 1.76056 9.80982"
          stroke="url(#paint11_linear_5254_5986)"
          strokeWidth="0.401607"
        />
      </g>
      <g filter="url(#filter11_f_5254_5986)">
        <path
          d="M1.23828 9.27921C1.90065 9.78586 4.22575 10.5741 5.60103 10.2361C6.97633 9.89812 8.14333 8.27806 8.68288 7.72021"
          stroke="url(#paint12_linear_5254_5986)"
          strokeWidth="0.060241"
        />
      </g>
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1682 9.7151C19.486 9.7151 20.7614 8.4721 20.7614 5.88832C20.7614 3.30449 19.4722 2.06147 17.1682 2.06147H15.152V9.7151H17.1682ZM14 10.7766V1H17.1682C20.1168 1 21.9409 2.68994 21.9409 5.88832C21.9409 9.15645 20.0894 10.7766 17.1682 10.7766H14ZM24.8383 11C23.3845 11 22.397 10.2318 22.397 9.0028C22.397 7.66195 23.3159 6.92175 24.9617 6.92175H25.7983C27.0738 6.92175 27.8006 6.7821 27.8006 5.80442C27.8006 5.17591 27.3206 4.32397 25.7434 4.32397C24.5639 4.32397 23.7136 4.95248 23.549 6.0558H22.4244C22.5753 4.3938 23.8645 3.34631 25.7571 3.34631C27.7321 3.34631 28.8978 4.2681 28.8978 5.83238V10.7765H27.8555L27.8006 8.79325H27.7458C27.4715 10.148 26.3469 11 24.8383 11ZM23.5628 8.8491C23.5628 9.58935 24.0154 10.0503 25.0851 10.0503C26.7583 10.0503 27.8006 8.7374 27.8006 7.5782V6.76815H27.7458C27.6498 7.3966 27.06 7.67595 25.7983 7.67595H24.9343C24.0565 7.67595 23.5628 8.09495 23.5628 8.8491ZM30.2386 3.56978V10.7765H31.3495V7.0614C31.3495 5.45524 32.241 4.37984 33.5302 4.37984C34.7919 4.37984 35.3954 5.03624 35.3954 6.25135V10.7765H36.4926V5.986C36.4926 4.40777 35.4777 3.34631 33.9416 3.34631C32.7073 3.34631 31.8158 4.0586 31.4318 5.34353H31.3495L31.281 3.56978H30.2386ZM36.9465 4.40792V3.56994H38.2082V1.68445H39.3054V3.56994H41.253V4.40792H39.3054V8.8493C39.3054 9.6314 39.5934 9.93865 40.3203 9.93865C40.5946 9.93865 40.8963 9.8968 41.253 9.813V10.7069C40.9237 10.7907 40.5672 10.8465 40.2243 10.8465C38.7843 10.8465 38.2082 10.3576 38.2082 8.94705V4.40792H36.9465ZM41.3071 7.1056C41.3071 9.60335 42.745 10.8119 44.7475 10.8119C46.4679 10.8119 47.7444 9.7511 47.9462 8.1665H46.8441C46.6426 9.1199 45.9033 9.87195 44.7475 9.87195C43.4035 9.87195 42.4089 8.98565 42.3822 7.30705H47.9729L47.9753 7.2769C47.9881 7.11385 48 6.962 48 6.8102C48 4.8496 46.6022 3.45301 44.7207 3.45301C42.7046 3.45301 41.3071 4.78245 41.3071 7.1056ZM46.8978 6.55505H42.3822C42.4764 5.13159 43.4305 4.39301 44.6803 4.39301C46.0109 4.39301 46.8173 5.25247 46.8978 6.55505Z"
      fill="#6B7280"
    />
    <defs>
      <filter
        id="filter0_f_5254_5986"
        x="2.63355"
        y="1.29175"
        width="7.32274"
        height="5.02538"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in2="BackgroundImageFix" in="SourceGraphic" result="shape" />
        <feGaussianBlur stdDeviation="0.200803" result="effect1_foregroundBlur_5254_5986" />
      </filter>
      <filter
        id="filter1_f_5254_5986"
        x="8.43592"
        y="2.19715"
        width="3.22973"
        height="6.77416"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in2="BackgroundImageFix" in="SourceGraphic" result="shape" />
        <feGaussianBlur stdDeviation="0.100401" result="effect1_foregroundBlur_5254_5986" />
      </filter>
      <filter
        id="filter2_f_5254_5986"
        x="8.45148"
        y="2.14972"
        width="3.20251"
        height="6.75622"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in2="BackgroundImageFix" in="SourceGraphic" result="shape" />
        <feGaussianBlur stdDeviation="0.0301205" result="effect1_foregroundBlur_5254_5986" />
      </filter>
      <filter
        id="filter3_f_5254_5986"
        x="0.872254"
        y="-0.88507"
        width="9.27502"
        height="6.00989"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in2="BackgroundImageFix" in="SourceGraphic" result="shape" />
        <feGaussianBlur stdDeviation="0.050201" result="effect1_foregroundBlur_5254_5986" />
      </filter>
      <filter
        id="filter4_f_5254_5986"
        x="3.52576"
        y="1.43006"
        width="8.22973"
        height="3.02807"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in2="BackgroundImageFix" in="SourceGraphic" result="shape" />
        <feGaussianBlur stdDeviation="0.100401" result="effect1_foregroundBlur_5254_5986" />
      </filter>
      <filter
        id="filter5_f_5254_5986"
        x="0.125738"
        y="2.40015"
        width="4.31884"
        height="7.22899"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in2="BackgroundImageFix" in="SourceGraphic" result="shape" />
        <feGaussianBlur stdDeviation="0.200803" result="effect1_foregroundBlur_5254_5986" />
      </filter>
      <filter
        id="filter6_f_5254_5986"
        x="0.131228"
        y="1.58484"
        width="7.7727"
        height="8.52221"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in2="BackgroundImageFix" in="SourceGraphic" result="shape" />
        <feGaussianBlur stdDeviation="0.100401" result="effect1_foregroundBlur_5254_5986" />
      </filter>
      <filter
        id="filter7_f_5254_5986"
        x="-0.549307"
        y="7.3169"
        width="9.17674"
        height="3.68113"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in2="BackgroundImageFix" in="SourceGraphic" result="shape" />
        <feGaussianBlur stdDeviation="0.401607" result="effect1_foregroundBlur_5254_5986" />
      </filter>
      <filter
        id="filter8_f_5254_5986"
        x="1.69257"
        y="6.61298"
        width="7.48205"
        height="5.82483"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in2="BackgroundImageFix" in="SourceGraphic" result="shape" />
        <feGaussianBlur stdDeviation="0.050201" result="effect1_foregroundBlur_5254_5986" />
      </filter>
      <filter
        id="filter9_f_5254_5986"
        x="2.71949"
        y="6.2063"
        width="9.91649"
        height="6.40917"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in2="BackgroundImageFix" in="SourceGraphic" result="shape" />
        <feGaussianBlur stdDeviation="0.200803" result="effect1_foregroundBlur_5254_5986" />
      </filter>
      <filter
        id="filter10_f_5254_5986"
        x="-0.682856"
        y="2.33228"
        width="2.99462"
        height="8.01268"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in2="BackgroundImageFix" in="SourceGraphic" result="shape" />
        <feGaussianBlur stdDeviation="0.200803" result="effect1_foregroundBlur_5254_5986" />
      </filter>
      <filter
        id="filter11_f_5254_5986"
        x="1.11835"
        y="7.59882"
        width="7.68518"
        height="2.84924"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in2="BackgroundImageFix" in="SourceGraphic" result="shape" />
        <feGaussianBlur stdDeviation="0.050201" result="effect1_foregroundBlur_5254_5986" />
      </filter>
      <linearGradient
        id="paint0_linear_5254_5986"
        x1="3.64536"
        y1="3.9426"
        x2="8.94205"
        y2="2.32623"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.168435" stopColor="#544CA4" />
        <stop offset="1" stopColor="#8177E9" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5254_5986"
        x1="10.5538"
        y1="4.07326"
        x2="8.95488"
        y2="8.9068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#574EAA" />
        <stop offset="1" stopColor="#9488FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5254_5986"
        x1="10.5026"
        y1="1.71568"
        x2="11.2154"
        y2="8.77874"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopColor="white" stopOpacity="0.15" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5254_5986"
        x1="10.58"
        y1="1.7748"
        x2="11.2927"
        y2="8.83791"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C80FA" />
        <stop offset="0.744652" stopColor="#968AFA" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5254_5986"
        x1="9.54459"
        y1="1.55579"
        x2="2.17185"
        y2="3.5302"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B4A9FD" />
        <stop offset="0.425" stopColor="#C7BCFF" />
        <stop offset="1" stopColor="#9387FD" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_5254_5986"
        x1="11.3169"
        y1="2.31055"
        x2="4.13888"
        y2="4.25174"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.15" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_5254_5986"
        x1="1.96219"
        y1="2.80589"
        x2="2.12302"
        y2="8.93362"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A79BFE" stopOpacity="0" />
        <stop offset="1" stopColor="#9183FF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_5254_5986"
        x1="2.62698"
        y1="1.5875"
        x2="3.72303"
        y2="9.77989"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.15" />
        <stop offset="0.227299" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_5254_5986"
        x1="8.89313"
        y1="9.06943"
        x2="3.19523"
        y2="11.4136"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9387FD" />
        <stop offset="1" stopColor="#554CA5" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_5254_5986"
        x1="4.84367"
        y1="11.1573"
        x2="2.16031"
        y2="9.48458"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#554CA5" stopOpacity="0" />
        <stop offset="1" stopColor="#484095" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_5254_5986"
        x1="8.65817"
        y1="5.86367"
        x2="8.80697"
        y2="12.1956"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#48408F" stopOpacity="0.15" />
        <stop offset="1" stopColor="#48408F" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_5254_5986"
        x1="0.859656"
        y1="2.80518"
        x2="1.47141"
        y2="9.66657"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5B52B0" stopOpacity="0.15" />
        <stop offset="1" stopColor="#5950AB" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_5254_5986"
        x1="3.76689"
        y1="10.5392"
        x2="8.50543"
        y2="7.94377"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8F84FC" />
        <stop offset="1" stopColor="#9488FE" />
      </linearGradient>
    </defs>
  </svg>
);

export default FullDanteLogoGreyIcon;
